<template>
    <div class="overview-wrapper">
      <!-- Top Header -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="font-weight-bold mb-0">Overview</h4>
  
        <div class="d-flex align-items-center">
          <!-- Time Dropdown -->
          <span v-if="spinnerPlayStop == true" style="margin-right: 25px">
          <b-spinner label="Loading..." />
        </span>
          <b-dropdown
            id="time-range-dropdown"
            :text="selectedTimeRange"
            variant="outline-secondary"
            class="mr-2 time-dropdown"
            size="sm"
          >
            <b-dropdown-item @click="setTimeRange('1 Hour')">Last 1 Hour</b-dropdown-item>
            <b-dropdown-item @click="setTimeRange('24 Hours')">Last 24 Hours</b-dropdown-item>
            <b-dropdown-item @click="setTimeRange('7 Days')">Last 7 Days</b-dropdown-item>
            <b-dropdown-item @click="setTimeRange('30 Days')">Last 30 Days</b-dropdown-item>
          </b-dropdown>
  
          <!-- Refresh Button -->
          <!-- <b-button variant="primary" size="sm" @click="refreshData">
            <b-icon icon="arrow-clockwise" class="mr-1" /> Refresh
          </b-button> -->
        </div>
      </div>
  
      <b-row>
        <b-col md="3" sm="6" class="mb-4">
  <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
    <img src="/image.jfif" alt="Online" style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;" />
    <h2 class="font-weight-bold mb-1">0</h2>
    <p class="mb-1">Online Users</p>
    <small :class="onlineUsersChange >= 0 ? 'text-success' : 'text-danger'">
      <b-icon :icon="onlineUsersChange >= 0 ? 'arrow-up' : 'arrow-down'" />
        <!-- 0% increase -->
      <!-- {{ Math.abs(onlineUsersChange) }}% {{ onlineUsersChange >= 0 ? 'increase' : 'decrease' }} -->
    </small>
  </div>
</b-col>

<b-col md="3" sm="6" class="mb-4">
  <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
    <img src="/signup.png" alt="Signups" style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;" />
    <h2 class="font-weight-bold mb-1">{{ registeredUsers }}</h2>
    <p class="mb-1">Sign Ups</p>
    <small :class="registeredUsersChange >= 0 ? 'text-success' : 'text-danger'">
      <b-icon :icon="registeredUsersChange >= 0 ? 'arrow-up' : 'arrow-down'" />
      <!-- {{ Math.abs(registeredUsersChange) }}% {{ registeredUsersChange >= 0 ? 'increase' : 'decrease' }} -->
    </small>
  </div>
</b-col>

<b-col md="3" sm="6" class="mb-4">
  <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
    <img src="/install.png" alt="Installations" style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;" />
    <h2 class="font-weight-bold mb-1">{{ installations }}</h2>
    <p class="mb-1">Installations</p>
    <small :class="installationsChange >= 0 ? 'text-success' : 'text-danger'">
      <b-icon :icon="installationsChange >= 0 ? 'arrow-up' : 'arrow-down'" />
      <!-- {{ Math.abs(installationsChange) }}% {{ installationsChange >= 0 ? 'increase' : 'decrease' }} -->
    </small>
  </div>
</b-col>

<b-col md="3" sm="6" class="mb-4">
  <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
    <img src="/time.png" alt="Minutes" style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;" />
    <h2 class="font-weight-bold mb-1">{{ minutesWatched }}</h2>
    <p class="mb-1">Minutes Watched</p>
    <small :class="minutesWatchedChange >= 0 ? 'text-success' : 'text-danger'">
      <b-icon :icon="minutesWatchedChange >= 0 ? 'arrow-up' : 'arrow-down'" />
      <!-- {{ Math.abs(minutesWatchedChange) }}% {{ minutesWatchedChange >= 0 ? 'increase' : 'decrease' }} -->
    </small>
  </div>
</b-col>

<b-col md="3" sm="6" class="mb-4">
  <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
    <img src="/subacription.png" alt="Subscriptions" style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;" />
    <h2 class="font-weight-bold mb-1">{{ subscriptions }}</h2>
    <p class="mb-1">Subscriptions</p>
    <small :class="subscriptionsChange >= 0 ? 'text-success' : 'text-danger'">
      <b-icon :icon="subscriptionsChange >= 0 ? 'arrow-up' : 'arrow-down'" />
      <!-- {{ Math.abs(subscriptionsChange) }}% {{ subscriptionsChange >= 0 ? 'increase' : 'decrease' }}  -->
    </small>
  </div>
</b-col>

  <!-- <b-col md="3" sm="6" class="mb-4">
    <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
      <img
        style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;"
        src="/image.jfif"
        alt="Online"
      />
      <h2 class="font-weight-bold mb-1">{{ onlineUsers }}</h2>
      <p class="mb-1">Online Users</p>
      <small class="text-success">
        <b-icon icon="arrow-up" /> 
        12% increase from last month
      </small>
    </div>
  </b-col>

  <b-col md="3" sm="6" class="mb-4">
    <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
      <img
        style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;"
        src="/signup.png"
        alt="Signups"
      />
      <h2 class="font-weight-bold mb-1">{{ registeredUsers }}</h2>
      <p class="mb-1">Sign Ups</p>
      <small class="text-success">
        <b-icon icon="arrow-up" />
         5% increase from last month
      </small>
    </div>
  </b-col>

  <b-col md="3" sm="6" class="mb-4">
    <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
      <img
        style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;"
        src="/install.png"
        alt="Installations"
      />
      <h2 class="font-weight-bold mb-1">{{installations}}</h2>
      <p class="mb-1">Installations</p>
      <small class="text-danger">
        <b-icon icon="arrow-down" /> 
        7% decrease from last month
      </small>
    </div>
  </b-col>

  <b-col md="3" sm="6" class="mb-4">
    <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
      <img
        style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;"
        src="/time.png"
        alt="Minutes"
      />
      <h2 class="font-weight-bold mb-1">{{minutesWatched}}</h2>
      <p class="mb-1">Minutes Watched</p>
      <small class="text-success">
        <b-icon icon="arrow-up" />
         10% increase from last month
      </small>
    </div>
  </b-col>

  <b-col md="3" sm="6" class="mb-4">
    <div class="stat-card p-3 text-center bg-white rounded shadow-sm">
      <img
        style="width: 48px; height: 48px; object-fit: contain; margin-bottom: 8px;"
        src="/subacription.png"
        alt="Subscriptions"
      />
      <h2 class="font-weight-bold mb-1">{{ subscriptions }}</h2>
      <p class="mb-1">Subscriptions</p>
      <small class="text-danger">
        <b-icon icon="arrow-down" /> 
        3% decrease from last month
      </small>
    </div>
  </b-col> -->
</b-row>

    
    </div>
  </template>
  
  <script>
  import { 
    BRow, BCol, BButton, BDropdown, BDropdownItem, BIcon 
    ,  BSpinner,

} from "bootstrap-vue";
import axios from 'axios';

  export default {
    components: {
      BRow,
      BCol,
      BButton,
      BDropdown,
      BDropdownItem,
      BIcon,
      BSpinner,
    },
    data() {
      return {
        spinnerPlayStop: true, 
        onlineUsers:0,
        registeredUsers:0,
        installations:0,
        subscriptions:0,
        minutesWatched:0,
        selectedTimeRange: "1 Hour",
      };
    },
    mounted() {
    this.refreshData();
    },
    methods: {
    refreshData() {
    console.log("Data refreshed for:", this.selectedTimeRange);
    this.spinnerPlayStop = true;

    const timeMap = {
        "1 Hour": "1hour",
        "24 Hours": "24hours",
        "7 Days": "7days",
        "30 Days": "30days",
    };

    const range = timeMap[this.selectedTimeRange] || "1hour";

    axios
        .get(process.env.VUE_APP_API_URL + "/heartbeat", {
        params: { range },
        headers: {
            Authorization: "Bearer " + localStorage.getItem("_t"),
        },
        })
        .then((res) => {
        const data = res.data;
        this.installationsChange = data.installationsChange;
        this.subscriptionsChange = data.subscriptionsChange;
        this.registeredUsersChange = data.registeredUsersChange;
        this.minutesWatchedChange = data.minutesWatchedChange;

        this.registeredUsers = data.registeredUsers;
        this.installations = data.installations;
        this.subscriptions = data.subscriptions;
        this.minutesWatched = data.minutesWatched;
        this.onlineUsers = data.onlineUsers;
        this.spinnerPlayStop = false;

        console.log("Registered Users:", this.registeredUsers);
        })
        .catch((err) => {
        console.error("Error fetching metrics", err);
        this.spinnerPlayStop = false;

        });
    },






      setTimeRange(range) {
        this.selectedTimeRange = range;
        console.log("Selected Time Range:", range);
        this.refreshData(); 
      },
    },
  };
  </script>
  <style scoped>
  .stat-card {
    border-radius: 1rem;
    border: 1px solid #eaeaea;
  }
  </style>

  